import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import type { Content } from '@plone/types';
import type { ContentState } from '../types';

interface UseContentSelectionProps {
  content?: Content;
}

/**
 * Custom Hook for content selection
 * Chooses between props.content and Redux state content
 */
export const useContentSelection = ({
  content: propsContent,
}: UseContentSelectionProps): Content => {
  const stateContent = useSelector((state: ContentState) => state.content.data);

  // Memoized content selection - performance optimization
  const content = useMemo(() => {
    return propsContent && (propsContent?.['@id'] || propsContent?.parent)
      ? propsContent
      : stateContent;
  }, [propsContent, stateContent]);

  return content;
};
